import './Text.css';



export function WeatherBody() {
  return (
    <div class="body">
      <div class="row" id="GalleryThree">
  <div class="column" >   
                      <h4>Weather Body, 2025
                        <br/>
            Poetry Anthology.
             <br/><br/>
             Perfect-bound book with transparency cover.
                </h4>
                </div>
</div>
<div class="row" id="GalleryOne">

<img src="WeatherBody02.jpeg"></img>
<img src="WeatherBody03.jpeg"></img>
<img src="WeatherBody04.jpeg"></img>
<img src="WeatherBody05.jpeg"></img>
<img src="WeatherBody06.jpeg"></img>
<img src="WeatherBody07.jpeg"></img>
<img src="WeatherBody08.jpeg"></img>
<img src="WeatherBody09.jpeg"></img>
<img src="WeatherBody10.jpeg"></img>
<img src="WeatherBody11.jpeg"></img>
<img src="WeatherBody12.jpeg"></img>
<img src="WeatherBody13.jpeg"></img>
<img src="WeatherBody14.jpeg"></img>
<img src="WeatherBody15.jpeg"></img>
<img src="WeatherBody16.jpeg"></img>
<img src="WeatherBody17.jpeg"></img>
<img src="WeatherBody18.jpeg"></img>
<img src="WeatherBody19.jpeg"></img>
<img src="WeatherBody20.jpeg"></img>
<img src="WeatherBody21.jpeg"></img>
<img src="WeatherBody22.jpeg"></img>
<img src="WeatherBody23.jpeg"></img>

</div></div>





  );
}
